<!--菜单编辑新建模块
创建人：lijt
时间：2017-08-04-->
<template>
	<div class="float-e-margins ibox-content ibox-main" v-loading="loadingstatus" element-loadig-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">名称</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="editMenu.name"/>
				</div>
				<label class="col-sm-1 control-label">父ID</label>
					<div class="col-sm-2">
						<input type="text" id="EditGroup_list" class="form-control menuInput" v-model="queryGroup" autocomplete="off" disableautocomplete @focus="showMenu" readonly>
						<div id="EditContentM" class="menuContentF" style="display:none; position: absolute;">
							<ul id="EditGroupTree" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
						</div>
					</div>
				<label class="col-sm-1 control-label">类型</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="editMenu.type">
						<option v-for="item in typeArr" :value="item.value">{{item.textName}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">权限</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="editMenu.permission"/>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">CODE</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="editMenu.code"/>
				</div>
				<label class="col-sm-1 control-label">功能树显示</label>
				<div class="col-sm-2">
					<select v-model="editMenu.showType" class="form-control">
						<option v-for="item in showTypeArr" :value="item.value">{{item.textName}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">是否启用</label>
				<div class="col-sm-2">
					<select v-model="editMenu.isEnable" class="form-control" disabled="disabled">
						<option v-for="item in EnableArr" :value="item.value">{{item.textName}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">图标</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="editMenu.icon"/>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">是否选中</label>
				<div class="col-sm-2">
					<select v-model="editMenu.checkOn" class="form-control">
						<option v-for="item in selectArr" :value="item.value">{{item.textName}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">依赖关系</label>
				<div class="col-sm-2">
					<select v-model="editMenu.dependence" class="form-control" disabled="true">
						<option v-for="item in dependArr" :value="item.value">{{item.textName}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">显示顺序</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="editMenu.orderNO"/>
				</div>
				<label class="col-sm-1 control-label" v-if="url">URL</label>
				<div class="col-sm-2" v-if="url">
					<input type="text" class="form-control" v-model="editMenu.url"/>
				</div>
				<label class="col-sm-1 control-label" v-if="pageCode">页面编码</label>
				<div class="col-sm-2" v-if="pageCode">
					<input type="text" class="form-control" v-model="editMenu.pageCode"/>
				</div>
			</div>
			<div class="form-group mt30px">
				<div class="col-sm-12 text-center">
					<button class="btn btn-primary" @click="setConfirm">保存</button>
					<button class="btn btn-primary" @click="closeSub">关闭</button>
				</div>
			</div>
		</div>
		<sub-modal ref="setConfirm" size="small" title="提示">
				{{messageStr}}
				<div slot="footer">
					<button class="btn btn-primary" @click="confirmSubBtn">确定</button>
				</div>
		</sub-modal>
		<sub-modal ref="modalMsg" size="small" title="提示">
				{{messageStr}}
				<div slot="footer">
					<button class="btn btn-primary" @click="closeModalMsg('modalMsg')">确定</button>
				</div>
		</sub-modal>
	</div>
</template>

<script>
	import SubModal from 'components/common/SubModal'
	import { OPERATE_EXCEPTION  } from 'static/message'
	 import { queryTree } from 'util/util'
	export default{
		props:["item","mode","groupList"],
		components:{
			SubModal,
		},
		data(){
			return{
				editMenu:{
					checkOn:null,
					isEnable:null,
					dependence:null,
					showType:null,
					code:null,
					orderNO:null,
					parentId:null,
					permission:null,
					icon:null,
					type:null,
					pageCode:null,
					url:null,
				},
				queryGroup:'',
				zTreeNodes:[],
				loadingstatus:false,
				selectArr:[
					{value:0,textName:"未选中"},
					{value:1,textName:"已选中"}
				],
				dependArr:[
					{value:0,textName:"未依赖"},
					{value:1,textName:"依赖"}
				],
				EnableArr:[
					{value:0,textName:"未启用"},
					{value:1,textName:"已启用"}
				],
				showTypeArr:[
					{value:0,textName:"不显示"},
					{value:1,textName:"组织机构显示"},
					{value:2,textName:"权限组显示"}
				],
				typeArr:[
					{value:1,textName:"菜单"},
					{value:2,textName:"功能"},
					{value:3,textName:"接口 "},
					{value:4,textName:"前端控件 "}
				],
				messageStr:'',
				setting: {
					data: {
						key: {
							name: "name"
						},
						simpleData: {
							enable: true,
							idKey: "menuId",
							pIdKey: "parentId"
						}
					},
					view: {
						dblClickExpand: false,
						selectedMulti: false,
						autoCancelSelected: true
					},
					callback: {
						onClick: this.onClick
					}
				},
				setting2: {
					data: {
						key: {
							name: "name"
						},
						simpleData: {
							enable: false
						}
					},
					view: {
						dblClickExpand: false,
						selectedMulti: false,
						autoCancelSelected: true
					},
					callback: {
						onClick: this.onClick
					}
				}
			}
		},
		computed:{
			pageCode(){
				return this.editMenu.type==4;
			},
			url(){
				return this.editMenu.type==3;
			}
		},
		watch:{
			item(val){
				this.editMenu=this.deepCopy(val);
				if(mode==0){
					this.editMenu.isEnable=1;
				}
				let treeObj=$.fn.zTree.getZTreeObj("EditGroupTree");
				let id=val.parentId;
				let node=treeObj.getNodeByParam("menuId",id);
				this.queryGroup = node.name;
				treeObj.selectNode(node);
			},
			groupList(){
				let a=$("#EditGroupTree");
				this.treeInit();
			},
			queryGroup(val){
				if(val){
					let nodeList = queryTree(this.zTreeNodes, val);
						//将找到的nodelist节点更新至Ztree内
					for( var i=0, l=nodeList.length; i<l; i++) {
						nodeList[i].open = false;
					}
	        		$.fn.zTree.init($("#EditGroupTree"), this.setting2, nodeList);
				}else{
					$.fn.zTree.init($("#EditGroupTree"), this.setting,this.groupList);
				}
			},
			"editMenu.type"(){
				this.editMenu.pageCode='';
				this.editMenu.url='';
			}
		},
		methods:{
			showMenu(){
				$(".menuContentF").slideDown("fast");
				$("body").bind("mousedown", this.onBodyDown);
			},
			onBodyDown(event){
				var self = this;
				if (!(event.target.id == "EditGroup_list" || event.target.id == "EditContentM" || $(event.target).parents(".menuContentF").length>0)) {
					this.hideMenu();
				}
			},
			hideMenu() {
				$(".menuContentF").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDown);
			},
			//z-tree 相关
			treeInit(){//初始化z-tree树
				$.fn.zTree.init($("#EditGroupTree"), this.setting, this.groupList);
				this.$nextTick(()=>{
					this.zTreeNodes = $.fn.zTree.getZTreeObj("EditGroupTree").getNodes();
				})
			},
			onClick(e,treeId,treeNode){//点击树节点
				this.editMenu.parentId= treeNode.menuId;
				this.queryGroup = treeNode.name;
			}, 
			closeSub(){
				this.$emit('cancel');
				this.editMenu={};
			},
			setConfirm(){
				this.messageStr='确认保存此次操作？'
				this.openModalMsg('setConfirm');
			},
			confirmSubBtn() {
				this.closeModalMsg('setConfirm');
				if(this.editMenu.orderNO>=32767){
					this.messageStr='显示顺序超过最大值';
					this.openModalMsg('modalMsg');
					return;
				}
				if(this.mode==0){//判断是否为新增项
					const para = {
					checkOn: this.editMenu.checkOn,		                                // 处理人
					isEnable: this.editMenu.isEnable,			                        // 处理结果
					dependence: this.editMenu.dependence,						                            // 处理状态
					showType: this.editMenu.showType,		                                    // 处理时间
					code: this.editMenu.code,		                            // 处理方式
					orderNO: this.editMenu.orderNO,		                            				// 报警消息ID
					parentId: this.editMenu.parentId,
					permission: this.editMenu.permission,
					icon: this.editMenu.icon,
					type: this.editMenu.type,
					name: this.editMenu.name,
				}
					this.loadingstatus=true;
					this.$http.post(process.env.API_ROOT + '/system/menu',para)
					.then((res) => {
						this.loadingstatus=true;
						if(res.body.success) {
								this.refData()
						} else {
							this.messageStr=res.body.message;
							this.openModalMsg('modalMsg');
						}
						this.loadingstatus=false;
					}, (res) => {
						this.messageStr=res.body.message;
						this.openModalMsg('modalMsg');
						this.loadingstatus=false;
					})
					.catch((res) => {
						this.messageStr=OPERATE_EXCEPTION;
						this.openModalMsg('modalMsg');
						this.loadingstatus=false;
					})
				}else{
					const para = {
					checkOn: this.editMenu.checkOn,		                                // 处理人
					isEnable: this.editMenu.isEnable,			                        // 处理结果
					dependence: this.editMenu.dependence,						                            // 处理状态
					showType: this.editMenu.showType,		                                    // 处理时间
					code: this.editMenu.code,		                            // 处理方式
					orderNO: this.editMenu.orderNO,		                            				// 报警消息ID
					parentId: this.editMenu.parentId,
					permission: this.editMenu.permission,
					icon: this.editMenu.icon,
					type: this.editMenu.type,
					name: this.editMenu.name,
				}
				this.loadingstatus=true;
				this.$http.put(process.env.API_ROOT + '/system/menu/'+this.editMenu.menuId,para)
				.then((res) => {//修改项
						if(res.body.success) {
							this.refData();
						} else {
							this.messageStr=res.body.message;
							this.openModalMsg('modalMsg');
						}
						this.loadingstatus=false;
					}, (res) => {
						this.messageStr=res.body.message;
						this.openModalMsg('modalMsg');
						this.loadingstatus=false;
					})
					.catch((res) => {
						this.messageStr=OPERATE_EXCEPTION;
						this.openModalMsg('modalMsg');
						this.loadingstatus=false;
					})
				}
			},
			openModalMsg(ref){
				this.$refs[ref].open();
			},
			closeModalMsg(ref){
				this.$refs[ref].close();
			},
			deepCopy:function(source){
				var result={};
				for (var key in source) {
					result[key] = typeof source[key]==='object'? this.deepCopy(source[key]): source[key];
				} 
			   	return result; 
			},
			refData(){
				this.closeSub();
				this.$emit('refData')
			}
		}
	}
</script>

<style>
	#menuSelect{
		width: 128px;
		height:30px;
	},
	.menuInput {
		position: relative;
	}
	.menuContentF{
		position:absolute;
		top:31px;
		left:6px;
		border:1px solid #ddd;
		z-index:999;
	}
</style>


// WEBPACK FOOTER //
// PageSystemMenuEdit.vue?5e7fa625